module.exports = __webpack_public_path__ + "img/logria-logo.379344c6.png";